import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { toast } from '../../../lib/toast';
import { API, auth, errMsg, fmtDate } from '../finance/shared';
import CoachProfileModal from './CoachProfileModal';
import CoachContractModal from './CoachContractModal';

const STATUS_LABELS = { pending_activation: 'بانتظار التفعيل', active: 'نشطة', suspended: 'معلقة', ended: 'منتهية' };
const STATUS_COLORS = { pending_activation: 'bg-amber-50 text-amber-700', active: 'bg-teal-50 text-teal-700', suspended: 'bg-orange-50 text-orange-700', ended: 'bg-slate-100 text-slate-500' };

export default function CoachStaffTab() {
  const [items, setItems] = useState([]);
  const [teams, setTeams] = useState([]);
  const [categories, setCategories] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [profileCoachId, setProfileCoachId] = useState(null);
  const [contractMembership, setContractMembership] = useState(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [m, t, c, e] = await Promise.all([
        axios.get(`${API}/coaches/memberships`, auth()),
        axios.get(`${API}/teams`, auth()),
        axios.get(`${API}/categories`, auth()),
        axios.get(`${API}/employees`, auth()),
      ]);
      setItems(m.data); setTeams(t.data); setCategories(c.data); setEmployees(e.data);
    } catch { setItems([]); }
    setLoading(false);
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (id, action) => {
    try { await axios.put(`${API}/coaches/memberships/${id}/${action}`, {}, auth()); toast.success('تم التحديث'); load(); }
    catch (err) { toast.error(errMsg(err, 'فشل التحديث')); }
  };

  return (
    <div className="space-y-4" data-testid="coach-staff-tab">
      {loading ? <p className="text-sm text-slate-400">جارِ التحميل...</p> : items.length === 0 ? (
        <p className="rounded-xl border border-dashed border-slate-200 py-10 text-center text-sm text-slate-400" data-testid="coach-staff-empty">لا يوجد طاقم تدريبي مرتبط بعد</p>
      ) : (
        <div className="space-y-2">
          {items.map((m) => (
            <div key={m.id} className="flex items-center justify-between rounded-xl border border-slate-200 bg-white p-4" data-testid="coach-staff-row">
              <div>
                <div className="text-sm font-bold text-slate-800">{m.coach_name} — {m.title}</div>
                <div className="text-xs text-slate-500">{m.season && `موسم ${m.season} · `}منذ {fmtDate(m.start_date)}</div>
              </div>
              <div className="flex items-center gap-2">
                <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${STATUS_COLORS[m.status]}`}>{STATUS_LABELS[m.status]}</span>
                <button onClick={() => setProfileCoachId(m.coach_id)} className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:border-teal-300" data-testid="coach-staff-profile-btn">السيرة الذاتية</button>
                <button onClick={() => setContractMembership(m)} className="rounded-lg border border-slate-200 px-3 py-1.5 text-xs font-semibold text-slate-600 hover:border-teal-300" data-testid="coach-staff-contract-btn">عرض العقد</button>
                {m.status === 'pending_activation' && <button onClick={() => act(m.id, 'activate')} className="rounded-lg bg-[#16233b] px-3 py-1.5 text-xs font-semibold text-white" data-testid="coach-staff-activate-btn">تفعيل</button>}
                {m.status === 'active' && <button onClick={() => act(m.id, 'suspend')} className="rounded-lg border border-orange-200 px-3 py-1.5 text-xs font-semibold text-orange-600" data-testid="coach-staff-suspend-btn">تعليق</button>}
                {(m.status === 'active' || m.status === 'suspended') && <button onClick={() => act(m.id, 'end')} className="rounded-lg border border-red-200 px-3 py-1.5 text-xs font-semibold text-red-600" data-testid="coach-staff-end-btn">إنهاء</button>}
              </div>
            </div>
          ))}
        </div>
      )}

      <CoachProfileModal coachId={profileCoachId} onClose={() => setProfileCoachId(null)} />
      <CoachContractModal membership={contractMembership} teams={teams} categories={categories} employees={employees} onClose={() => setContractMembership(null)} />
    </div>
  );
}
